export default defineAppConfig({
  platform: {
    id: 'bitbeli',
    name: 'Bitbeli',
    domain: 'https://bitbeli.cz',
  },
})
